import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { Calc, Supplier } from 'services/FragnetService';

// Types
export interface SettingsState {
  selectedCalcs: Calc[];
  selectedSupplier?: Supplier;
  defaultGroupLimit: number;
}

// Slice

const initialState: SettingsState = {
  // Default calculations are hard coded to this could need to change if the endpoint changes
  selectedCalcs: [
    {
      id: 'LOGP',
      name: 'logp',
      description: 'cLogP',
      type: 'number',
    },
  ],
  defaultGroupLimit: 25,
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    toggleSelectedCalc(state, action: PayloadAction<Calc>) {
      if (state.selectedCalcs.map((calc) => calc.name).includes(action.payload.name)) {
        state.selectedCalcs = state.selectedCalcs.filter(
          (calc) => calc.name !== action.payload.name,
        );
      } else {
        state.selectedCalcs.push(action.payload);
      }
    },
    changeSelectedSupplier(state, action: PayloadAction<Supplier>) {
      state.selectedSupplier = action.payload;
    },
    changeDefaultGroupLimit(state, action: PayloadAction<number>) {
      if (action.payload > 0) {
        state.defaultGroupLimit = action.payload;
      }
    },
  },
});

// Selectors

export const settingsStateSelector = (state: RootState, ..._: any): SettingsState => state.settings;

export const getDefaultGroupLimit = createSelector(
  settingsStateSelector,
  (state) => state.defaultGroupLimit,
);
export const getSelectedCalculations = createSelector(
  settingsStateSelector,
  (state) => state.selectedCalcs,
);
export const getSelectedSupplier = createSelector(
  settingsStateSelector,
  (state) => state.selectedSupplier,
);

// Exports

export const {
  toggleSelectedCalc,
  changeSelectedSupplier,
  changeDefaultGroupLimit,
} = settingsSlice.actions;

// Extract the action creators object and the reducer
export const { actions, reducer } = settingsSlice;

// Export the reducer, either as a default or named export
export default settingsSlice.reducer;
